import { Box } from '@chakra-ui/react';
import { Container } from 'components/Layout/Container';
import Image from 'next/image';
import Link from 'next/link';
import { useTheme } from 'styled-components';

const Header = () => {
  const { padding } = useTheme();

  return (
    <Container display="flex" py={padding.lg} justifyContent="center">
      <Link href="/" passHref>
        <Box
          as="a"
          cursor="pointer"
          maxW={200}
          w="100%"
          pos="relative"
          height="40px"
        >
          <Image
            layout="fill"
            src="/images/logo-dark.png"
            objectFit="contain"
            priority
          />
        </Box>
      </Link>
    </Container>
  );
};

export default Header;
